import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";

type ResponseType<T> = {
    success: boolean;
    statusCode?: number;
    message?: string;
    data?: T;
};

//INFO: (new) 출입 기록 트래킹 활성화 여부 설정하기
export const changeActiveEntryLogging = async (isEntryLoggingEnabled: boolean): Promise<ResponseType<boolean>> => {
    try {
        const res = await instance.patch("/visitors/setting/entry-logging", {
            isEntryLoggingEnabled: isEntryLoggingEnabled,
        });
        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: { isEntryLoggingEnabled: isEntryLoggingEnabled } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};

export const updateWalkInVisitVisitorTracking = async (purposeId: string, isVisitorTrackingEnabled: boolean): Promise<boolean> => {
    try {
        const res = await instance.patch("/visitors/setting/device/walk-in-visit/purpose/visitor-tracking", {
            id: purposeId,
            isVisitorTrackingEnabled: isVisitorTrackingEnabled,
        });
        return res.data.result;
    } catch (error) {
        Sentry.captureException(error, {
            extra: {
                id: purposeId,
                isVisitorTrackingEnabled: isVisitorTrackingEnabled,
            },
        });
        return false;
    }
};

export const updateDoorBell = async (isDoorBellEnabled: boolean): Promise<boolean> => {
    try {
        const res = await instance.patch("/visitors/setting/doorbell", {
            isDoorBellEnabled: isDoorBellEnabled,
        });
        return res.data.result;
    } catch (error) {
        Sentry.captureException(error, {
            extra: {
                isDoorBellEnabled: isDoorBellEnabled,
            },
        });
        return false;
    }
};

export const getUsageWalkInVisit = async (): Promise<boolean> => {
    try {
        const res = await instance.get("/visitors/setting/walk-in-visit");
        return res.data.isWalkInVisitEnabled;
    } catch (error) {
        Sentry.captureException(error);
        return false;
    }
};

export const updateUsageWalkInVisit = async (isWalkInVisitEnabled: boolean): Promise<boolean> => {
    try {
        const res = await instance.patch("/visitors/setting/walk-in-visit", {
            isWalkInVisitEnabled: isWalkInVisitEnabled,
        });
        return res.data.result;
    } catch (error) {
        Sentry.captureException(error, { extra: { isWalkInVisitEnabled: isWalkInVisitEnabled } });
        return false;
    }
};
